import APP_CONST from 'const/app-const';

export function isStrictAppAdmin(user: { isAdmin?: boolean | number | string } | null | undefined): boolean {
    if (!user) return false;
    return user.isAdmin === true || user.isAdmin === 1 || user.isAdmin === '1';
}

export function getStoredAppUser(): Record<string, unknown> | null {
    try {
        const raw = localStorage.getItem(APP_CONST.KEY_STORE_USER);
        if (!raw) return null;
        return JSON.parse(raw) as Record<string, unknown>;
    } catch {
        return null;
    }
}

export function storedUserIsStrictAppAdmin(): boolean {
    const user = getStoredAppUser();
    return isStrictAppAdmin(user as { isAdmin?: boolean | number | string });
}
